export const SET_WORKSTATIONS = 'SET_WORKSTATIONS';
export const SET_ACTIVEWORKSTATIONS = 'SET_ACTIVEWORKSTATIONS';
export const SET_SELECTEDWORKSTATION = 'SET_SELECTEDWORKSTATION';
export const SET_NOSELECTEDWORKSTATION = 'SET_NOSELECTEDWORKSTATION';



